import { render, staticRenderFns } from "./TarefasDeApostas.vue?vue&type=template&id=3fcc55cb&scoped=true"
import script from "./TarefasDeApostas.vue?vue&type=script&lang=js"
export * from "./TarefasDeApostas.vue?vue&type=script&lang=js"
import style1 from "./TarefasDeApostas.vue?vue&type=style&index=1&id=3fcc55cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc55cb",
  null
  
)

export default component.exports